import React, { Component } from 'react';

import Radio from '../RadioGroupIcon/Radio/Radio';
import classes from './RadioGroup.module.css';
import PropTypes from 'prop-types';

class RadioGroup extends Component {
  _setValue = (value) => {
    this.props.radioClicked(value);
  };

  _renderRadios = () => {
    let longestText = '';
    this.props.options.map((o) => {
      if (longestText.length < o.text.length && !o.text.includes('&')) {
        longestText = o.text;
      }
      return null;
    });
    return this.props.options.map((o, i) => {
      return (
        <Radio
          key={i}
          optionText={o.text}
          optionValue={o.value}
          selected={this.props.selected[o.value] === o.value + 1}
          radioClicked={this._setValue.bind(this, o.value)}
          largerRadio={this.props.largerRadio}
          longestText={longestText}
          isLandscape={this.props.isLandscape}
        />
      );
    });
  };

  render() {
    // console.log('//////// RADIO RENDERS ', this.props);
    return (
      <div
        className={
          this.props.hideThird ? classes.RadioGroupHidden : classes.RadioGroup
        }
        style={this.props.style}
      >
        {this._renderRadios()}
      </div>
    );
  }
}

RadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  radioClicked: PropTypes.func.isRequired,
};

RadioGroup.defaultProps = {
  style: {},
};

export default RadioGroup;
